import { Link } from "react-router-dom";
import { AZIENDA } from "@/lib/config";
import { apriPreferenze } from "@/lib/consenso";

export const Footer = () => (
  <footer className="border-t border-slate-200 bg-white" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10 flex flex-col md:flex-row gap-6 justify-between text-sm text-slate-600">
      <div>
        <p className="font-extrabold text-slate-900 text-base">{AZIENDA.nome}</p>
        <p className="mt-1">Pronto intervento idraulico H24 in provincia di Rimini · Impianti civili, industriali e speciali · 30 anni di esperienza</p>
        <a href={AZIENDA.mappaLink} target="_blank" rel="noreferrer" className="mt-1 inline-flex items-center min-h-10 py-1 hover:text-sky-700 underline sm:no-underline" data-testid="footer-indirizzo-link">{AZIENDA.indirizzo}</a>
        <p className="mt-1" data-testid="footer-piva">P.IVA {AZIENDA.piva}</p>
      </div>
      <div className="grid grid-cols-2 gap-x-4 sm:flex sm:flex-wrap sm:gap-x-6 sm:gap-y-2 [&>*]:py-2.5 sm:[&>*]:py-0 [&>*]:text-left">
        <a href={AZIENDA.telefonoLink} className="hover:text-sky-700" data-testid="footer-call-link">{AZIENDA.telefono}</a>
        <a href={AZIENDA.whatsappLink} target="_blank" rel="noreferrer" className="hover:text-sky-700" data-testid="footer-whatsapp-link">WhatsApp</a>
        <a href={AZIENDA.emailLink} className="hover:text-sky-700 col-span-2 break-all" data-testid="footer-email-link">{AZIENDA.email}</a>
        <Link to="/gestione" className="hover:text-sky-700" data-testid="footer-gestione-link">Area gestione</Link>
        <Link to="/privacy" className="hover:text-sky-700" data-testid="footer-privacy-link">Privacy</Link>
        <button onClick={apriPreferenze} className="hover:text-sky-700" data-testid="footer-preferenze-btn">Preferenze privacy</button>
      </div>
    </div>
  </footer>
);
